export default {
  setFinanciamentos(state, payload) {
    state.financiamentos = payload
  }
}
